import { AppState } from '@ttstr/reducers';
import { AnyAction, ActionCreator } from 'redux';
import { ThunkAction } from 'redux-thunk';

export * from './brands';
export * from './cart';
export * from './categories';
export * from './events';
export * from './locations';
export * from './merchants';
export * from './masonry';
export * from './orders';
export * from './tags';
export * from './tickets';
export * from './products';

// export type ThunkActionCreator = (...args: any[]) => ThunkAction<Promise<any>, AppState, void, AnyAction>;
export type ThunkActionCreator = ActionCreator<ThunkAction<Promise<any>, AppState, void, AnyAction>>;
